'use strict';

angular.module('atex.art').factory('ArtReloadModal',
['$rootScope', '$q', '$modal',

  function($rootScope, $q, $modal) {
    return {
      create: function(props) {
        var modalScope = $rootScope.$new(true);
        _.extend(modalScope, props);

        modalScope.serverBusy = false;
        modalScope.clientBusy = false;

        var modal = $modal({
          show: true,
          scope: modalScope,

          template: 'templates/reload-modal.html',
          modalClass: 'reload-modal ng-cloak',
          backdrop: 'static',
          keyboard: false
        });

        var deferred = $q.defer();

        var destroyModal = function() {
          modal.then(function(modalEl) {
            modalEl.on('hidden.bs.modal', function() {
              modalScope.$destroy();
            });

            modalEl.modal('hide');
          });
        };

        modalScope.useServerArticle = function() {
          modalScope.serverBusy = true;
          deferred.resolve({ resolution: 'server' });
        };

        modalScope.useLocalArticle = function() {
          modalScope.clientBusy = true;
          deferred.resolve({ resolution: 'local' });
        };

        return {
          whenResolved: function() {
            return deferred.promise;
          },

          destroy: function() {
            return destroyModal();
          }
        };
      }
    };
  }
]);
